import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Success() {
  const navigate = useNavigate();
  const [count, setCount] = useState(3);

  useEffect(() => {
    const timer = setInterval(() => {
      setCount((prev) => prev - 1);
    }, 1000);

    const redirect = setTimeout(() => {
      navigate("/dashboard/student");  // ← tumhara student dashboard route
    }, 3000);

    return () => {
      clearInterval(timer);
      clearTimeout(redirect);
    };
  }, []);

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      background: "#000",
      color: "#fff",
      textAlign: "center",
      padding: "2rem"
    }}>
      <div style={{ fontSize: "5rem", marginBottom: "1rem" }}>🎉</div>
      
      <h1 style={{ 
        color: "#e6be5d", 
        fontSize: "2.5rem",
        marginBottom: "1rem" 
      }}>
        Payment Successful!
      </h1>
      
      <p style={{ 
        color: "#ddd", 
        fontSize: "1.2rem",
        marginBottom: "0.5rem" 
      }}>
        Welcome to your subscription!
      </p>
      
      <p style={{ 
        color: "#888", 
        fontSize: "14px",
        marginBottom: "2rem" 
      }}>
        Redirecting to dashboard in {count} seconds...
      </p>

      {/* Manual redirect button */}
      <button
        onClick={() => navigate("/dashboard/student")}
        style={{
          backgroundColor: "#e6be5d",
          color: "#000",
          padding: "12px 28px",
          borderRadius: "6px",
          border: "none",
          fontWeight: "bold",
          cursor: "pointer",
          fontSize: "16px"
        }}
      >
        Go to Dashboard Now
      </button>
    </div>
  );
}